module.exports = __webpack_public_path__ + "static/media/hs_18.6aae05c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_18.jpg
// module id = 5949
// module chunks = 0